export abstract class DateConstants {
  public static get defaultDate() {
    return 'dd/MM/yyyy';
  }

  public static get dateWithTime() {
    return `dd/MM/yyyy HH:mm`;
  }
}
